import { nanoid } from 'nanoid'

import { SpendVariance } from '@webapp/components/SpendVariance'
import { CostSummary } from '@webapp/core/components/CostSummary'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../../messages'

export interface IBudgetCategoryCardDetailsBreakdownVarianceRowProps {
  variance: number | string
  variancePercentage: number | string
  danger?: boolean
}

export const BudgetCategoryCardDetailsBreakdownVarianceRow = ({
  variance,
  variancePercentage,
  danger,
}: IBudgetCategoryCardDetailsBreakdownVarianceRowProps) => {
  const id = nanoid()
  const intl = useProcurifyIntl()

  return (
    <CostSummary.Cost>
      <th id={id}>{intl.formatMessage(messages.varianceLabel)}</th>
      <td aria-labelledby={id}>
        <SpendVariance
          variance={variance}
          variancePercentage={variancePercentage}
          isOverBudget={danger}
        />
      </td>
    </CostSummary.Cost>
  )
}

BudgetCategoryCardDetailsBreakdownVarianceRow.displayName =
  'BudgetCategoryCardDetailsBreakdownVarianceRow'
